import { pfm as api } from './client';

export function fetchFareRules(offerId: string) {
  return api.airflow.rules(offerId).then(({ data }) => data);
}
